export const NOTIFY_VISITOR_REQUEST = 'NOTIFY_VISITOR_REQUEST';
export const NOTIFY_VISITOR_SUCCESS = 'NOTIFY_VISITOR_SUCCESS';
export const NOTIFY_VISITOR_FAILURE = 'NOTIFY_VISITOR_FAILURE';
